<script>
  
  let { content, dataTestId = 'base-markdown', simpleStyles } = $props();
</script>

<div
  class="mx-auto max-w-6xl px-4 mt-12 markdown-wrapper"
  class:prose={!simpleStyles}
  class:lg:prose-lg={!simpleStyles}
  class:lg:mb-22={!simpleStyles}
  class:mb-2={simpleStyles}
  class:lg:mt-8={simpleStyles}
  class:lg:mb-4={simpleStyles}
  data-testid={dataTestId}
>
  {@html content}
</div>
